import { Request, BaseApiUrl } from "./api";

const url = `${BaseApiUrl}/api/Common`;

export const updateUserInfo = (parmas) => {
  return Request.post(`${url}/UpdateUserInfo`, parmas);
};
